import { DynamicField, DynamicForm, FieldVariant, SelectFieldProps, NumberFieldProps } from '@/components/form-builder/form-builder.types';
import { SeuilsGlobalRepository } from '@/store/seuils-global-state/seuils-global.repository';
import { map, of } from 'rxjs';

interface ISeuilFormObjectProps {
  store: SeuilsGlobalRepository;
  typeMarcherOptions: { name: string; code: number }[];
  isUpdateMode?: boolean;
}

export const getSeuilFormObject = ({ store, typeMarcherOptions, isUpdateMode = false }: ISeuilFormObjectProps): DynamicForm => {
  const typeMarcherField: DynamicField<SelectFieldProps> = {
    label: 'settings.seuils.form.typeMarcher.label',
    variant: FieldVariant.SELECT,
    isRequired: true,
    isDisabled: of(isUpdateMode),
    props: {
      placeholder: 'settings.seuils.form.typeMarcher.placeholder',
      options: typeMarcherOptions,
      value: store.getNestedObservable('dto', 'typeMarcherId').pipe(
        map(id => {
          if (!id) return undefined;
          return typeMarcherOptions.find(option => option.code === id);
        })
      ),
      onSelectChange: (value: any) => {
        store.setNested('dto', 'typeMarcherId', value?.code || 0);
      },
    },
  };

  const montantField: DynamicField<NumberFieldProps> = {
    label: 'settings.seuils.form.seuil.label',
    variant: FieldVariant.NUMBER,
    isRequired: true,
    props: {
      value: store.getNestedObservable('dto', 'montant'),
      onChange: (value: number) => {
        store.setNested('dto', 'montant', value);
      },
      placeholder: 'settings.seuils.form.seuil.placeholder',
    },
  };

  return {
    title: 'settings.seuils.form.title',
    description: 'settings.seuils.form.description',
    isHeaderHidden: true,
    orientation: 'horizontal',
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [typeMarcherField],
          },
          {
            fields: [montantField],
          },
        ],
      },
    ],
  };
};
